app.filter('floor', [
    function (
    ) {
        return function (value) {
            return Math.floor(value);
        };
    },
]);
